import { AlphaCard, Spinner, Button, FormLayout, HorizontalGrid, Popover, TextField, VerticalStack, useBreakpoints } from "@shopify/polaris";

import {
  DetailText,
  H1,
  SubText,
  H2
} from './Components'

import iconMoney from '../assets/icon-money.png'
import iconProduct from '../assets/icon-product.png'
import iconLike from '../assets/icon-like.png'
import iconDiscount from '../assets/icon-discount.png'
import iconEngagement from '../assets/icon-engagement.png'
import iconSocial from '../assets/icon-social.png'
import LpForm from "./LpForm";
import { useState, useEffect } from "react";

function FeatureCard({ title, description, icon, width }) {
  return (
    <div style={{ border: '2px solid grey', width, padding: '15px', boxSizing: 'border-box', height: '250px', borderRadius: '10px', display: 'flex', textAlign: "center", justifyContent: 'center', alignItems: 'center', margin: '10px 0' }}>
      <VerticalStack gap="3" inlineAlign="center">
        <img src={icon} alt="icon" style={{ height: '50px', width: '50px' }} />
        <DetailText>{title}</DetailText>
        <SubText>{description}</SubText>
      </VerticalStack>
    </div>
  )
}

export default function ClassicTemplate({ fields, setLocalFields }) {

  const { mdDown } = useBreakpoints()
  const primaryColor = fields?.styles?.primaryColor ? fields.styles.primaryColor : 'green'
  const secondaryColor = fields?.styles?.secondaryColor ? fields.styles.secondaryColor : 'black'

  console.log('secondaryColor', secondaryColor)
  console.log('SC', fields?.styles?.secondaryColor)

  console.log('fields', fields)

  return (
    <div style={{ boxSizing: 'border-box' }}>
      <div style={{ width: '100%', backgroundColor: 'white', minHeight: '80px', marginBottom: '50px', textAlign: mdDown ? 'center' : 'center' }}>
        <img src={fields.storeData?.logo} alt="logo" style={{ height: '100px', padding: '10px 20px' }} />
      </div>
      <div style={{ width: '100%', backgroundColor: '#f1f1f1' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '50px', width: '100%' }}>
          <div style={{ width: mdDown ? '100%' : '50%', maxWidth: '1500px', height: '90%', display: 'flex', justifyContent: 'space-around', flexDirection: mdDown ? 'column' : 'row' }}>
            <div style={{
              width: mdDown ? '100%' : '47%',
              height: '300px',
              backgroundColor: 'lightgray',
              background: `url(${fields?.hero?.image ? fields?.hero?.image : 'https://assets.codepen.io/6060109/default-lp-hero-1.jpg'})`,
              backgroundSize: fields?.hero?.size === 'Full Width' ? '100%' : fields?.hero?.size === 'Full Height' ? 'auto 100%' : fields?.hero?.size === 'Contain' ? 'contain' : 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: fields?.hero?.position === 'top' ? 'top' : fields?.hero?.position === 'center' ? 'center' : 'bottom',
            }} />
            <div style={{ width: mdDown ? '100%' : '47%', height: mdDown ? '250px' : '300px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'start', textAlign: mdDown ? 'center' : 'left' }}>
              <H1>{fields?.hero?.header}</H1>
              <SubText>{fields?.hero?.subheader}</SubText>
              <div style={{ display: 'flex', justifyContent: mdDown ? 'center' : 'start' }}>
                <button style={{ backgroundColor: primaryColor, color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px', width: '250px', padding: '20px 10px', fontSize: '18px' }} onClick={() => {
                  document.getElementById('form').scrollIntoView({
                    behavior: 'smooth'
                  });
                }}>
                  {fields?.hero?.button}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div style={{ width: '100%', backgroundColor: secondaryColor, height: mdDown ? 'inherit' : '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 0', textAlign: 'center' }}>
          <div>
            <p style={{ fontSize: '24px', color: 'white', padding: mdDown ? '0' : '0 20%', lineHeight: "1.2" }}>{fields?.about?.text}</p>
          </div>
        </div>
        <div style={{ width: '100%', backgroundColor: '#f1f1f1', marginBottom: '50px', display: 'flex', alignItems: 'center', flexDirection: 'column', padding: '80px 0' }}>
          <div style={{ marginBottom: '40px' }}>
            <VerticalStack inlineAlign="center">
              <H2>{fields?.featuresOne?.header}</H2>
              <SubText>{fields?.featuresOne?.subheader}</SubText>
            </VerticalStack>
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', marginBottom: '100px', maxWidth: '1200px', flexDirection: mdDown ? 'column' : 'row' }}>
            <FeatureCard title={fields?.featuresOne?.features[0]?.title} description={fields?.featuresOne?.features[0]?.text} icon={iconSocial} width={mdDown ? '100%' : '30%'} />
            <FeatureCard title={fields?.featuresOne?.features[1]?.title} description={fields?.featuresOne?.features[1]?.text} icon={iconLike} width={mdDown ? '100%' : '30%'} />
            <FeatureCard title={fields?.featuresOne?.features[2]?.title} description={fields?.featuresOne?.features[2]?.text} icon={iconEngagement} width={mdDown ? '100%' : '30%'} />
          </div>
          <div style={{ marginBottom: '40px' }}>
            <VerticalStack inlineAlign="center">
              <H2>{fields?.featuresTwo?.header}</H2>
              <SubText>{fields?.featuresTwo?.subheader}</SubText>
            </VerticalStack>
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around', marginBottom: '100px', maxWidth: '1000px', flexDirection: mdDown ? 'column' : 'row' }}>
            <FeatureCard title={fields?.featuresTwo?.features[0]?.title} description={fields?.featuresTwo?.features[0]?.text} icon={iconProduct} width={mdDown ? '100%' : '30%'} />
            <FeatureCard title={fields?.featuresTwo?.features[1]?.title} description={fields?.featuresTwo?.features[1]?.text} icon={iconDiscount} width={mdDown ? '100%' : '30%'} />
            <FeatureCard title={fields?.featuresTwo?.features[2]?.title} description={fields?.featuresTwo?.features[2]?.text} icon={iconMoney} width={mdDown ? '100%' : '30%'} />
          </div>
          <div id="form" style={{ marginBottom: '100px', width: '100%' }}>
            <VerticalStack inlineAlign="center">
              <VerticalStack gap="2" inlineAlign="center">
                <H2>Apply Now</H2>
                <SubText>Submit the Form to Apply For Our Program!</SubText>
              </VerticalStack>
              <div style={{ width: mdDown ? '100%' : '50%', padding: mdDown ? '10px 0' : '40px 70px', marginTop: '20px', backgroundColor: primaryColor, borderRadius: '20px', maxWidth: '700px' }}>
                <AlphaCard>
                  <div style={{ padding: mdDown ? '20px 0' : "20px 60px" }}>
                    <LpForm customFields={fields?.customFields} setCustomFields={(key, value) => {
                      setLocalFields({
                        ...fields,
                        customFields: {
                          ...fields.customFields,
                          [key]: value
                        }
                      })
                    }} />
                  </div>
                </AlphaCard>
              </div>
            </VerticalStack>
          </div>
          {
            /*
            <div style={{ marginBottom: '100px' }}>
              <VerticalStack gap="5" inlineAlign="center">
                <H2>FAQ</H2>
                <SubText>Submit the Form to Apply For Our Program!</SubText>
              </VerticalStack>
            </div>
              */
          }
          <div style={{ marginBottom: '100px' }}>
            <VerticalStack gap="5" inlineAlign="center">
              <H2>{fields?.contact?.header}</H2>
              <SubText>{fields?.contact?.email}</SubText>
              {
                /*
                <p>Social Icons</p>
                  */
              }
            </VerticalStack>
          </div>
        </div>
      </div>
    </div>

  )
}
